// ใบข้อมูลสินค้า → ไฟล์ Excel สำหรับชิปปิ้ง/broker (28 ต.ค. 2569)
//
// ทำไมต้อง Excel ไม่ใช่ PDF: ชิปปิ้ง "กรอกคำตอบลงไฟล์เดียวกันแล้วส่งกลับ" — ไฟล์ DoD ที่ Yusen ตีกลับมา
//   (DoD-details28-4 (J28166).xls) เติม HS Code · เพิ่มคอลัมน์ "HS Code Yusen" · Duty · License ลงในชีตของเราตรง ๆ
//   PDF ทำแบบนั้นไม่ได้ ต้องพิมพ์ใหม่ทั้งหมด
//
// รูปแบบ = แบบที่ผู้ประสานงานคนเดิมส่งชิปปิ้งมาตลอด (EVERNEW / NANGA / DoD-details*.xlsx — ตรวจของจริงแล้ว):
//   · 1 ชีตต่อ 1 invoice ตั้งชื่อชีต "INV No. <เลข invoice>" · ตารางเริ่ม A1 ไม่มีหัวบริษัท
//   · คอลัมน์: No | Pic | Item No. | Name | Description | Materials | HS Code | Duty | License
//   · แถวสูง ~160–178pt มีรูปใหญ่ในช่อง Pic · Description/Materials เป็นภาษาไทย
//   🚨 ห้ามสลับลำดับ 9 คอลัมน์แรก — ชิปปิ้งทำงานกับตำแหน่งเดิม ของที่เราเพิ่มให้ต่อท้ายหลัง License เท่านั้น
//
// ข้อมูลเพิ่มท้ายตาราง = สิ่งที่ใบ PDF ของเรามีแต่แบบเดิมไม่มี (จำนวน · คืออะไร/ใช้ทำอะไร · ถิ่นกำเนิด · สเปคไฟ · DG)
// ⚠ ไม่ใส่ราคา/ต้นทุนใด ๆ — ไฟล์นี้ออกนอกบริษัท
//
// หาวัสดุด้วย AI (deploy-38): ต่อท้ายหลัง DG อีก 2 คอลัมน์ — วัสดุอังกฤษตามผู้ผลิต + แหล่งข้อมูล (ข้อความธรรมดา ไม่ใช่ลิงก์)
//   ความสูงแถวคงเดิม: fixImageAnchors คิดตำแหน่งรูปจากแถวสูงเท่ากันทุกแถว เปลี่ยนรายแถวแล้วรูปเคลื่อนใน Quick Look

import { materialSourceText } from './materials.js';

// ⚠ ห้ามตั้งกว้าง 9 พอดี — exceljs ถือว่า 9 = ค่าเริ่มต้นแล้วไม่เขียนลงไฟล์ (Excel ใช้ 8.43 แทน)
const COLS = [
  // key        header           width
  ['no',        'No',            7],
  ['pic',       'Pic',           44],
  ['sku',       'Item No.',      20],
  ['name',      'Name',          34],
  ['desc',      'Description',   30],
  ['material',  'Materials',     38],
  ['hs',        'HS Code',       20],
  ['duty',      'Duty',          10],
  ['license',   'License',       13],
  // ── ต่อท้าย (ของเรา) ──
  ['qty',       'Qty',           10],
  ['unit',      'Unit',          8],
  ['usage',     'What it is / Usage', 42],
  ['origin',    'Origin',        10],
  ['power',     'Power spec',    16],
  ['dg',        'DG',            7],
  // ── ต่อท้าย (หาวัสดุด้วย AI) — ห้ามแทรกก่อน DG ──
  ['material_en',  'Materials (EN ตามผู้ผลิต)', 38],
  ['material_src', 'แหล่งข้อมูลวัสดุ', 44],
];
const ROW_PT = 160;                 // ความสูงแถวสินค้า (pt) — ใกล้แบบเดิม (166–178pt)
// กรอบรูปในช่อง Pic (px) — ช่อง Pic กว้าง 308px · แถว 160pt ≈ 213px ตามสูตร Excel
// ⚠ ต้องเว้นขอบพอ ๆ กับไฟล์อ้างอิง (~79% กว้าง · ~58% สูง): ตัวเปิดไฟล์แต่ละตัวคำนวณขนาดช่องไม่เท่ากัน
//   เคยตั้ง 300×200 (เต็ม 97%) → Quick Look วาดรูปล้นช่อง พื้นขาวของรูปทับเส้นตาราง (ทดสอบ 28 ต.ค.)
const IMG_BOX = { w: 245, h: 165 };
const IMG_MAX = 640;                // ย่อรูปก่อนฝัง — 114 แถวต้องไม่กลายเป็นไฟล์หลายสิบ MB
const FONT = { name: 'Tahoma', size: 11 };   // มีอักษรไทยทั้ง Windows และ Mac

const t = (v) => String(v ?? '').trim();
// ชื่อชีตตามกติกา Excel: ≤31 ตัว · ห้าม [ ] : * ? / \\ · ห้ามขึ้นต้น/ลงท้ายด้วย ' (exceljs throw)
//   และ ' กลางชื่อทำให้ Print_Titles เสีย (exceljs ไม่ escape) → เปลี่ยนเป็น ’ · ห้ามชื่อ History (Excel จองไว้)
const safeSheet = (s) => {
  const v = t(s).replace(/[\u0000-\u001f\u007f]/g, '').replace(/[\[\]:*?/\\]/g, '-').replace(/'/g, '\u2019')
    .slice(0, 31).trim();
  return v && v.toLowerCase() !== 'history' ? v : 'Sheet1';
};
export const safeFileName = (s) => t(s).replace(/[\\/:*?"<>|]+/g, '-').replace(/\s+/g, ' ').slice(0, 120) || 'details';

// รูป → JPEG ย่อขนาด (dataURL) · รองรับ WebP ที่ Excel เปิดไม่ได้ · พื้นขาวแทนโปร่งใส
async function loadPhoto(url, timeoutMs = 15000) {
  const ctl = new AbortController();
  const timer = setTimeout(() => ctl.abort(), timeoutMs);
  try {
    const res = await fetch(url, { signal: ctl.signal });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const blob = await res.blob();
    if (!blob.type.startsWith('image/')) throw new Error('ไม่ใช่รูป');
    const bmp = await createImageBitmap(blob);
    try {
      const scale = Math.min(1, IMG_MAX / Math.max(bmp.width, bmp.height));
      const w = Math.max(1, Math.round(bmp.width * scale)), h = Math.max(1, Math.round(bmp.height * scale));
      const cv = document.createElement('canvas');
      cv.width = w; cv.height = h;
      const ctx = cv.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, w, h);
      ctx.drawImage(bmp, 0, 0, w, h);
      return { dataUrl: cv.toDataURL('image/jpeg', 0.85), w, h };
    } finally { bmp.close?.(); }
  } finally { clearTimeout(timer); }
}

// ── ขนาดจริงตามสูตรของ Excel (หน่วย EMU: 1 px = 9525 · 1 pt = 12700) ──
const EMU_PX = 9525, EMU_PT = 12700;
const colPx = (w) => Math.trunc(((256 * w + Math.trunc(128 / 7)) / 256) * 7);   // MDW 7 (ฟอนต์มาตรฐาน)

// exceljs เขียนรูปเป็น oneCellAnchor + ขนาดใน <a:xfrm> = 0×0 · Excel อ่านได้ แต่ Quick Look / Numbers / ตัวพรีวิวอื่น
// ใช้ xfrm → รูปหายทั้งไฟล์ (ทดสอบจริง 28 ต.ค.: ไฟล์ของผู้ประสานงานคนเดิมโชว์รูป ของเราไม่โชว์)
// และ offset ในช่องที่ exceljs คำนวณใช้ความกว้างช่องแบบประมาณ (width×10000 EMU) ไม่ตรงของจริง
// → แปลงเป็น twoCellAnchor แบบเดียวกับไฟล์อ้างอิง · จัดรูปกลางช่องด้วยขนาดช่องจริง · ใส่ขนาด/ตำแหน่งจริงใน xfrm
async function fixImageAnchors(buf, { colWidths, headPt, rowPt, picCol }) {
  const { default: JSZip } = await import('jszip');
  const zip = await JSZip.loadAsync(buf);
  const colEmu = colWidths.map(w => colPx(w) * EMU_PX);
  const xBefore = colEmu.slice(0, picCol).reduce((a, b) => a + b, 0);
  const cellW = colEmu[picCol], cellH = rowPt * EMU_PT;
  for (const path of Object.keys(zip.files).filter(f => /^xl\/drawings\/drawing\d+\.xml$/.test(f))) {
    let xml = await zip.file(path).async('string');
    xml = xml.replace(
      /<xdr:oneCellAnchor([^>]*)>\s*<xdr:from><xdr:col>(\d+)<\/xdr:col><xdr:colOff>\d+<\/xdr:colOff><xdr:row>(\d+)<\/xdr:row><xdr:rowOff>\d+<\/xdr:rowOff><\/xdr:from>\s*<xdr:ext cx="(\d+)" cy="(\d+)"\s*\/>([\s\S]*?)<\/xdr:oneCellAnchor>/g,
      (m, attrs, col, row, cx, cy, rest) => {
        const w = Math.min(+cx, cellW), h = Math.min(+cy, cellH);
        const offX = Math.max(0, Math.floor((cellW - w) / 2)), offY = Math.max(0, Math.floor((cellH - h) / 2));
        const r = +row;   // 0-based · แถว 0 = หัวตาราง
        const absX = xBefore + offX, absY = headPt * EMU_PT + (r - 1) * cellH + offY;
        const body = rest.replace(/<a:xfrm>[\s\S]*?<\/a:xfrm>/,
          `<a:xfrm><a:off x="${absX}" y="${absY}"/><a:ext cx="${w}" cy="${h}"/></a:xfrm>`);
        return `<xdr:twoCellAnchor${attrs}>`
          + `<xdr:from><xdr:col>${col}</xdr:col><xdr:colOff>${offX}</xdr:colOff><xdr:row>${r}</xdr:row><xdr:rowOff>${offY}</xdr:rowOff></xdr:from>`
          + `<xdr:to><xdr:col>${col}</xdr:col><xdr:colOff>${offX + w}</xdr:colOff><xdr:row>${r}</xdr:row><xdr:rowOff>${offY + h}</xdr:rowOff></xdr:to>`
          + `${body}</xdr:twoCellAnchor>`;
      });
    zip.file(path, xml);
  }
  return zip.generateAsync({ type: 'arraybuffer', compression: 'DEFLATE' });
}

// ทำงานพร้อมกันทีละ n — ไม่ยิงรูป 114 รูปพร้อมกัน
async function pool(items, n, fn) {
  const out = new Array(items.length);
  let i = 0;
  const worker = async () => { while (i < items.length) { const k = i++; out[k] = await fn(items[k], k); } };
  await Promise.all(Array.from({ length: Math.min(n, items.length) }, worker));
  return out;
}

// consignment = แถว consignment (+ shipment) · items = line_item พร้อม product_classification (แบบหน้า Dossier)
// onProgress(done, total) ระหว่างโหลดรูป
export async function buildDossierXlsx({ consignment: c, items }, { onProgress } = {}) {
  const mod = await import('exceljs');
  const ExcelJS = mod.default ?? mod;

  const wb = new ExcelJS.Workbook();
  wb.creator = 'CAMP STUDIO';
  wb.created = new Date();

  const sheetName = safeSheet(c?.invoice_no ? `INV No. ${t(c.invoice_no)}` : `${t(c?.supplier_name)} ${t(c?.shipment?.code)}`);
  const ws = wb.addWorksheet(sheetName, {
    views: [{ state: 'frozen', ySplit: 1 }],
    pageSetup: { paperSize: 9, orientation: 'landscape', fitToPage: true, fitToWidth: 1, fitToHeight: 0 },
  });
  ws.pageSetup.printTitlesRow = '1:1';
  ws.columns = COLS.map(([key, header, width]) => ({ key, header, width }));

  const border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
  const head = ws.getRow(1);
  head.height = 22;
  for (let i = 1; i <= COLS.length; i++) {
    const cell = head.getCell(i);
    cell.font = { ...FONT, bold: true };
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
    cell.border = border;
    // ช่องที่ชิปปิ้งกรอก = พื้นเหลืองอ่อน · ช่องของเรา = เทา
    const brokerCol = ['hs', 'duty', 'license'].includes(COLS[i - 1][0]);
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: brokerCol ? 'FFFFF4CC' : 'FFEFEFEF' } };
  }

  // ── รูป: โหลดก่อน (พร้อมกันทีละ 6) ──
  const urls = items.map(li => t(li.product_classification?.photos?.[0]?.url));
  let done = 0;
  const photos = await pool(urls, 6, async (u) => {
    if (!u) { onProgress?.(++done, urls.length); return { missing: true }; }
    try { const p = await loadPhoto(u); onProgress?.(++done, urls.length); return p; }
    catch (e) { onProgress?.(++done, urls.length); return { failed: true, reason: e?.message ?? String(e) }; }
  });

  let withPhoto = 0, noPhoto = 0, failed = 0;
  items.forEach((li, idx) => {
    const cl = li.product_classification ?? {};
    const usage = [t(cl.what_is_it), t(cl.usage_desc)].filter(Boolean)
      .filter((v, i, a) => a.indexOf(v) === i).join(' · ');
    const row = ws.addRow({
      no: idx + 1,
      sku: t(cl.sku || li.sku),
      // ชื่ออังกฤษ = ชื่อรุ่นตรงกับ invoice (แบบเดิมของชิปปิ้งใช้ชื่ออังกฤษ)
      name: t(cl.name_en) || t(li.description) || t(cl.name_th),
      // Description = ชื่อไทยที่ใช้สำแดง (แบบเดิม: "เต็นท์" · "ที่จับหม้อ") — ไม่มีค่อยใช้ "คืออะไร"
      //   ⚠ ใบสินค้าที่สร้างจาก PD/invoice บางใบ "ชื่อไทย" เป็นภาษาอังกฤษ (ก๊อปชื่อมา) → เลือกอันที่มีอักษรไทยก่อน
      desc: [t(cl.name_th), t(cl.what_is_it)].find(v => /[\u0E00-\u0E7F]/.test(v)) || t(cl.name_th) || t(cl.what_is_it),
      material: t(cl.material),
      hs: t(cl.hs_code) ? `${t(cl.hs_code)}${cl.hs_confirmed ? '' : ' (รอยืนยัน)'}` : '',
      duty: '', license: '',
      qty: Number.isFinite(Number(li.qty)) ? Number(li.qty) : null,
      unit: t(li.unit),
      usage,
      origin: t(cl.origin_country),
      power: t(cl.power_spec),
      dg: cl.is_dangerous_goods ? 'YES' : '',
      material_en: t(cl.material_en),
      material_src: materialSourceText(cl, li.material_provenance),
    });
    row.height = ROW_PT;
    for (let i = 1; i <= COLS.length; i++) {
      const cell = row.getCell(i);
      cell.font = FONT;
      cell.alignment = { vertical: 'middle', wrapText: true, horizontal: ['no', 'qty', 'unit', 'origin', 'dg'].includes(COLS[i - 1][0]) ? 'center' : 'left' };
      cell.border = border;
    }
    // รหัส/พิกัด = ข้อความเสมอ — กัน Excel ตัดศูนย์นำหน้าหรือแปลง 6505.00.90 เป็นตัวเลข
    row.getCell('sku').numFmt = '@';
    row.getCell('hs').numFmt = '@';

    const p = photos[idx];
    if (p?.dataUrl) {
      const k = Math.min(IMG_BOX.w / p.w, IMG_BOX.h / p.h, 1);
      const id = wb.addImage({ base64: p.dataUrl, extension: 'jpeg' });
      // ตำแหน่ง/ขนาดในช่องถูกจัดใหม่ทีหลังด้วยขนาดช่องจริง (fixImageAnchors) — ตรงนี้ใส่แค่ช่องกับขนาดรูป
      ws.addImage(id, {
        tl: { col: 1, row: row.number - 1 },   // ช่อง B (0-based col 1)
        ext: { width: Math.round(p.w * k), height: Math.round(p.h * k) },
        editAs: 'oneCell',
      });
      withPhoto++;
    } else {
      const cell = row.getCell('pic');
      cell.value = p?.failed ? 'โหลดรูปไม่ได้' : 'ไม่มีรูป';
      cell.font = { ...FONT, color: { argb: 'FF999999' } };
      cell.alignment = { vertical: 'middle', horizontal: 'center' };
      if (p?.failed) failed++; else noPhoto++;
    }
  });

  let buf = await wb.xlsx.writeBuffer();
  if (withPhoto) {
    buf = await fixImageAnchors(buf, { colWidths: COLS.map(c => c[2]), headPt: 22, rowPt: ROW_PT, picCol: 1 });
  }
  const blob = new Blob([buf], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  // ชื่อไฟล์แบบเดิม: <แบรนด์>-details-<invoice>.xlsx
  const fileName = `${safeFileName(`${t(c?.supplier_name) || 'supplier'}-details-${t(c?.invoice_no) || t(c?.shipment?.code) || 'invoice'}`)}.xlsx`;
  return { blob, fileName, sheetName, rows: items.length, withPhoto, noPhoto, failed };
}
